import React, { useEffect, useMemo, useState } from "react";
import CustomTable from "../../ui/custom-table";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../store/reducer/PopupReducer";
import {
  deleteEventData,
  EventApi,
  StatusChangeUseCaseMappping,
} from "../../api/api";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function UseCaseMap() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [event, setEvent] = useState([]);
  //console.log("event", event);
  const [loading, setLoading] = useState(false);
  const { showModal } = useSelector(
    (state) => state?.PopupReducer?.modal || {}
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500); // Debounce by 500ms

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const fecthEvents = async () => {
    setLoading(true);
    try {
      const search = debouncedSearch;
      const data = await EventApi(search, user_id, organization_id);
      if (data?.data?.status === true) {
        setEvent(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fecthEvents();
  }, [debouncedSearch]);

  useEffect(() => {
    if (showModal === false) {
      fecthEvents();
    }
  }, [showModal]);

  const handleStausChange = async (id, status) => {
    let payload = {
      status: status === true ? false : true,
    };
    try {
      const data = await StatusChangeUseCaseMappping(id, payload);
      if (data) {
        fecthEvents();
      }
    } catch (error) {}
  };

  const columns = useMemo(
    () => [
      { accessorKey: "camera_group_name", header: "Camera Group" },
      { accessorKey: "usecase_name", header: "Use Case" },
      { accessorKey: "operation", header: "Opreation" },
      {
        accessorKey: "created_at",
        header: "Created At",
        Cell: ({ cell }) => new Date(cell.getValue()).toLocaleDateString(),
      },
      {
        accessorKey: "Status",
        header: "status",
        Cell: ({ row }) => {
          const isActive = row.original.status;

          return (
            <div className="d-flex align-items-center gap-2">
              <label className="custom-toggle mb-0">
                <input
                  type="checkbox"
                  checked={isActive}
                  onChange={() => handleStausChange(row.original._id, isActive)}
                />
                <span className="slider"></span>
              </label>
              <span
                className={`fw-bold ${
                  isActive ? "text-success" : "text-danger"
                }`}
              >
                {isActive ? "Active" : "Inactive"}
              </span>
            </div>
          );
        },
      },
    ],
    []
  );

  const handleAddClick = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADDEVENT",
        showModal: true,
      })
    );
  };

  const handleEdit = (row) => {
    dispatch(
      SetPopupReducerData({
        modalType: "ADDEVENT",
        showModal: true,
        data: row._id,
      })
    );
  };

  const handleDelete = async (row) => {
    try {
      const deleteData = await deleteEventData(row._id);
      if (deleteData) {
        toast("deleted Successfully");
        fecthEvents();
      }
    } catch (error) {
      //console.log("error", error);
    }
  };
  return (
    <>
      <aside className="mainSection">
        <CustomTable
          columns={columns}
          data={event}
          loading={loading}
          showActions={true}
          onAddClick={handleAddClick}
          addButtonLabel="Add UseCase"
          onEdit={handleEdit}
          onDelete={handleDelete}
          onSearchChange={(e) => {
            setSearchTerm(e.target.value);
          }}
        />
      </aside>
    </>
  );
}

export default UseCaseMap;
